import { Contact } from '../components/Contact';

export function ContactPage() {
  return (
    <div className="min-h-screen">
      {/* Contact Section */}
      <div className="pt-20">
        <Contact />
      </div>
    </div>
  );
}

